import { render, staticRenderFns } from "./Journalism.vue?vue&type=template&id=5f9b2c2c&scoped=true&"
import script from "./Journalism.vue?vue&type=script&lang=js&"
export * from "./Journalism.vue?vue&type=script&lang=js&"
import style0 from "./Journalism.vue?vue&type=style&index=0&id=5f9b2c2c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9b2c2c",
  null
  
)

export default component.exports